const type = 'SET_CARD_SELECTED_STATUS';

const setCardSelectedStatus = (data) => ({
  data,
  type,
});

export { type };
export default setCardSelectedStatus;
